import { render, staticRenderFns } from "./settingsPosTextFields.vue?vue&type=template&id=7847b716&scoped=true&"
import script from "./settingsPosTextFields.vue?vue&type=script&lang=js&"
export * from "./settingsPosTextFields.vue?vue&type=script&lang=js&"
import style0 from "./settingsPosTextFields.vue?vue&type=style&index=0&id=7847b716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847b716",
  null
  
)

export default component.exports